import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function Gallery() {
  const [menuOpen, setMenuOpen] = useState(false);

  // News & Events
  const [newsEvents] = useState([
    {
      id: 1,
      title: 'The Joint Meeting of the Naturopathy Registration Board (NRB) Committees was convened on 18th July 2025 at Nisarggram, Pune, Maharashtra, in the esteemed presence of Joint Secretary, Ms. Monalisa Dash.',
      type: 'images',
      images: [
        'img/nrb1.jpg',
        'img/nrb2.jpg',
        'img/nrb3.jpg',
        'img/nrb4.jpg',
        'img/nrb5.jpg'
      ]
    },
    {
      id: 2,
      title: 'Naturopathy Registration Board (NRB) Committees Joint Meeting was held on 09th to 10th of February 2024 at Deham Nature Cure, Pune, Maharashtra',
      type: 'images',
      images: [
        'img/p1.jpg',
        'img/p2.jpg',
        'img/p4.jpg',
        'img/p6.jpg',
        'img/p7.jpg',
        
      ]
    },
    {
      id: 3,
      title: 'Shri Vaidya Rajesh Kotecha, Secretary, Ministry of AYUSH visited Naturopathy Registration Board on 14/12/2023',
      type: 'images',
      images: [
        'img/2.jpg',
        'img/3.jpg',
        'img/4.jpg',
        'img/6.jpg',
        'img/07.jpg'
      ]
    },
    {
      id: 5,
      title: 'On the occasion of 6th Naturopathy Day, Shri Vaidya Rajesh Kotecha, Secretary Ministry of AYUSH, Announced about Naturopathy Registration Board at the Inaugural function of "INTERNATIONAL CONFERENCE ON NATUROPATHY" held in University of Patanjali, Haridwar on 18th November 2023.',
      type: 'video',
      videoFile: 'img/kotecha.MP4'
    }
  ]);

  return (
    <div className="gallery-page">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>
          <Notification />
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="gallery-hero">
        <h1 className="gallery-main-heading">News & Events</h1>
        <p className="gallery-subtitle">Latest updates from NRB activities and meetings</p>
      </section>

      {/* News & Events Section */}
      <section className="news-events-section">
        <div className="content-wrapper">
          <div className="news-events-container">
            {newsEvents.map((newsItem) => (
              <div key={newsItem.id} className="news-event-card">
                <h3 className="news-event-title">{newsItem.title}</h3>
                {newsItem.type === 'video' ? (
                  <div className="news-event-video">
                    <div style={{
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                    }}>
                      <video
                        controls
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block'
                        }}
                      >
                        <source src={newsItem.videoFile} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                ) : (
                  <div className="news-event-images">
                    {newsItem.images.map((img, index) => (
                      <div key={index} className="news-event-img-item">
                        <img src={img} alt={`Event ${index + 1}`} className="news-event-img" />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Gallery;


